module.exports = __webpack_public_path__ + "img/shengfenzheng-mohu@2x.d3c872ee.png";